import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import store from 'store'
import Cookies from '../../static/js/js-cookie'

// 设置cookie保存的域名
let DOMAIN = '.91weijia.com'
let hostname = window.location.hostname.split('.')
if (hostname[hostname.length - 1] === 'cn') {
  DOMAIN = '.91weijia.cn'
}

Vue.use(Vuex)

const generatorUUID = () => {
  let ret = []
  do {
    ret.push(Math.floor(Math.random() * 10))
  } while (ret.length < 15)
  return ret.join('')
}

const mutations = {
  changeLogin (state, payload) {
    if (typeof payload === 'boolean') {
      payload = {
        show: payload,
        redirect: null
      }
    }
    state.toLogin = payload.show
    state.redirect = payload.redirect
  },
  updateToken (state, payload) {
    let token = store.get('token')
    let time = Date.now()
    if (token) {
      let out = (1 * 60 * 60 * 1000) + (token.time || 0)
      if (out < time) {
        store.remove('token')
        Cookies.remove('5i5aj-user-token')
        token = null
      }
    }
    if (payload && payload.uid && payload.mac) {
      token = Object.assign(token || {}, payload)
      token.time = time
    }
    if (token) {
      // token.time = time
      // store.set('token', token) // 不应该每次访问都修改过期时间
      // 设置cookie过期时间，默认是一小时
      let expires = (1 * 60 * 60 * 1000) + (token.time || 0)
      let domain = DOMAIN
      Cookies.set('5i5aj-user-token', token, {domain, expires: new Date(expires)})
    }
    store.set('token', token)
    state.token = token
  },
  clearToken (state) {
    store.remove('token')
    Cookies.remove('5i5aj-user-token')
    state.token = null
  },
  changeCity (state, payload) {
    let city = store.get('city')
    if (!city || /[A-Za-z]/.test(city.code)) {
      city = {
        name: '北京市',
        code: '110100',
        remarks: '4007705127'
      }
    }
    if (payload && payload.name && payload.code) {
      city = payload
    }
    store.set('city', state.city = city)
  },
  toggleAppointment (state, payload) {
    state.showAppointment = payload.show || false
    state.counselorId = payload.id || ''
  },
  updateCaptId (state, payload) {
    payload = payload || generatorUUID()
    state.captId = payload
  },
  updateHasConselor (state, payload) {
    state.hasConselor = payload
  },
  compareVersion (state, payload) {
    let version = store.get('version')
    if (payload && (version - payload < 0)) {
      state.version = payload
      store.set('version', payload)
      let search = window.location.search.replace(/v=\d+/, '')
      let hash = window.location.hash
      let patch = (u) => {
        return /\?$/.test(u) ? '' : /\?/.test(u) ? '&' : '?'
      }
      window.location.href = '/' + search + patch(search) + 'v=' + payload + hash
    } else {
      state.version = version
    }
  }
}

export default new Vuex.Store({
  state: {
    token: null,
    toLogin: false,
    city: {
      name: '',
      code: '',
      remarks: ''
    },
    captId: '',
    showAppointment: false,
    counselorId: '',
    hasConselor: false
  },
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/vuex/index.js